
<db-header design="2.0" class="w-100" [fluid]="true">
  <div class="db-header-base__link-item no-bg-hover">
    @if (sessionStorage.getItem('selectedFknKey')) {
    <p class="text-white d-flex flex-row space-between link">
      <db-icon class="mr-2" size="md">profile</db-icon>
      {{ width > 850 ? ('HEADER.' + getAppThemeName() + '.bcn' | translate) + ':' : '' }} {{ sessionStorage.getItem('selectedFknKey') }}
    </p>
    }
  </div>
  @if (width > 850) {
  <div class="db-header-base__link-item text-white">
    <a class="text-white text-decoration-none link" href="{{ 'HEADER.' + getAppThemeName() + '.link_2.href' | translate }}" target="_blank">
      {{ 'HEADER.' + getAppThemeName() + '.link_2.text' | translate }}
    </a>
  </div>
  }
  @if (width > 850) {
  <div class="db-header-base__link-item">
    <a class="text-white text-decoration-none link" href="{{ 'HEADER.' + getAppThemeName() + '.link_1.href' | translate }}" target="_blank">
      {{ 'HEADER.' + getAppThemeName() + '.link_1.text' | translate }}
    </a>
  </div>
  }
  <div class="db-header-base__link-item text-white">
    @if (getCookie('COOKIE_ACCEPTED') !== '') {
    <language-menu class="text-white link"></language-menu>
    }
  </div>
  @if (width < 850) {
  <db-menu [iconOnly]="true" design="tertiary" [label]="iconLabel">
    <db-menu-item>
      <div class="db-header-base__link-item">
        <a class="text-white text-decoration-none" href="{{ 'HEADER.' + getAppThemeName() + '.link_1.href' | translate }}" target="_blank">
          {{ 'HEADER.' + getAppThemeName() + '.link_1.text' | translate }}
        </a>
      </div>
    </db-menu-item>
    <db-menu-item>
      <div class="db-header-base__link-item text-white">
        <a class="text-white text-decoration-none" href="{{ 'HEADER.' + getAppThemeName() + '.link_2.href' | translate }}" target="_blank">
          {{ 'HEADER.' + getAppThemeName() + '.link_2.text' | translate }}
        </a>
      </div>
    </db-menu-item>
  </db-menu>
  }
</db-header>

<ng-template #iconLabel>
  <db-icon size="md" color="#fff">menu</db-icon>
</ng-template>
